export const home = {
  soon: "Coming Soon",
  soonLaunch: "Araria is in beta.",
  hero: {
    title: "All Premium AI Models in One Place",
    subtitle:
      "Why pay for multiple subscriptions? Access GPT-4, Claude, Gemini, Image and Video Generation and more in one place.",
    cta: "Prices",
    titleBottom: "Start for free now!",
    titleBottomDescription:
      "Free plan does not require a credit card, the free models are:",
  },
  providers: {
    title: "Access the Main AI Providers",
    subtitle: "One platform, multiple top AI models at your reach",
    openai: "OpenAI",
    anthropic: "Anthropic",
    google: "Google",
    mistral: "Mistral AI",
    deepseek: "DeepSeek",
    meta: "Meta AI",
    groq: "Groq",
    maritaca: "Maritaca AI",
    alibaba: "Alibaba",
    midjourney: "MidJourney",
    perplexity: "Perplexity",
    flux: "Flux",
    stabilityai: "Stability AI",
    ollama: "Ollama",
    runway: "Runway",
    runware: "Runware",
    playht: "PlayHT",
    decor8: "Decor8",
    civitai: "CivitAI",
    mxbai: "Mixedbread AI",
    cohere: "Cohere AI",
    suno: "Suno",
    kling: "Kling AI",
    viewModels: "Ver Modelos",
    whatsapp: "WhatsApp",
    twilio: "Twilio",
    contentful: "Contentful",
  },
  thirdParty: {
    title: "Third Party Integrations",
    subtitle: "Explore some of our official integrations",
  },
  typeAnimationFeatures: [
    {
      title:
        "Not satisfied with the ChatGPT/Claude/Gemini response? Test your conversation with multiple models using quick reprompt!",
    },
    {
      title: "Want to create videos? Use Kling AI, Runway and Hailuo and Luma!",
    },
    {
      title:
        "Top-line image generation? 🦄 Use CivitAI, Flux and MidJourney with super competitive prices!",
    },
    {
      title:
        "Need a soundtrack or music for your project? 🎶 Use Suno and Udio!",
    },
    {
      title:
        "Why not create personas with AI and chat with Gandhi in the style of Character.AI?",
    },
    {
      title:
        "Is your chatbot weak? Try using our Agents with scraping tools and knowledge base 🔥",
    },
    {
      title:
        "🦸 Give your Agents superpowers with tools to handle various challenges!",
    },
    {
      title:
        "There's so much you can do here, use the Folders to organize your chats and generations 😜",
    },
    {
      title:
        "Need to discover which AI model is best for your challenge? Compare results side by side!",
    },
    {
      title:
        "Need a chatbot for your site or store? Use the Agent Embed to plug in quickly!",
    },
    {
      title:
        "Start using Araria from R$ 36.00 deposit, no subscription, no commitment, does not expire.",
    },
    {
      title:
        "Need a custom solution for your business? We integrate with any system, CRM, ERP, APIs, etc.",
    },
    {
      title:
        "Your system or site needs intelligence? 🔮 Use our API, we provide endpoints for you to connect with Araria.",
    },
    {
      title:
        "In addition to our API, did you know we also have SDKs? Check out our SDKs for NodeJS and Python on GitHub!",
    },
  ],
  features: {
    title: "Maximize your workflow with AI",
    subtitle:
      "Unlock the full potential of AI with our comprehensive set of features",
    reprompting: {
      title: "Quick Reprompt",
      description:
        "Send your prompt to another model quickly to get a different result and benefit from the diversity of possible answers.",
    },
    upload: {
      title: "Upload Images and Documents",
      description:
        "Upload and analyze images or documents easily, allowing the AI to process visual information and extract insights.",
    },
    devices: {
      title: "Multiple devices",
      description:
        "Access the app on any device: Android, iPhone and Desktop. Quick access from the taskbar or phone.",
    },
    history: {
      title: "Chat History",
      description:
        "Access and review previous conversations, allowing continuity in discussions and easy reference to previous information.",
    },
    multilingual: {
      title: "Multilingual Models",
      description:
        "Communicate and generate content in multiple languages, breaking linguistic barriers and expanding global usability.",
    },
    folders: {
      title: "Folders",
      description:
        "Organize your chats and generations in folders to facilitate navigation and search for specific conversations.",
    },
    sideBySide: {
      title: "Side by Side Chat",
      description:
        "Chat with multiple AI models at the same time, to compare results and choose the best model for your task.",
    },
    memory: {
      title: "Memory",
      description:
        "Control how much memory is used as context to optimize your needs, balancing performance and cost.",
    },
    slides: {
      title: "Slides",
      description:
        "Generate presentations with AI, allowing you to create visual content for your projects or personal/commercial use.",
    },
    image: {
      title: "Image Generation",
      description:
        "Generate images using over 200,000 models from CivitAI and Flux, advanced controls and image manipulation.",
    },
    api: {
      title: "API",
      description:
        "Easily integrate Araria into your business processes and systems, with a diverse API and fair prices.",
    },
    agents: {
      title: "AI Agents",
      description:
        "Create and manage AI agents for different contexts and complex tasks, integrations and tools for automation.",
    },
    video: {
      title: "Video Generation",
      description:
        "Generate videos with a variety of providers to create visual content for your projects or personal/commercial use.",
    },
    characters: {
      title: "Characters",
      description:
        "Create characters/experts with AI, allowing specialized interactions with your touch, tone and knowledge base.",
    },
    users: {
      title: "Users",
      description:
        "Manage sub-users who can use your proprietary agents, create exclusive access for your expert agents.",
    },
    tools: {
      title: "Tools",
      description:
        "Give your agents superpowers with various tools, such as integrations with SERP, Geocoding, Web Search, Scraping and more.",
    },
  },
  futureFeatures: {
    title: "In development",
    subtitle:
      "We are constantly working to improve Araria and provide the best AI experience for you!",
    imageGeneration: {
      title: "Image Generation",
      description:
        "Generate images using AI models, allowing you to create visual content for your projects or personal/commercial use.",
    },
    videoGeneration: {
      title: "Video Generation",
      description:
        "Generate videos with a variety of providers to create visual content for your projects or personal/commercial use.",
    },
    assistant: {
      title: "Project Assistant",
      description:
        "Configure your ideal AI assistant by providing a context, so it can help you better in your project or daily task.",
    },
    agents: {
      title: "AI Agents",
      description:
        "Create and manage AI agents for different contexts and complex tasks, integrations with third-party services and tools to automate your workflow.",
    },
    enterpriseAPI: {
      title: "Enterprise API",
      description:
        "Access our API for volume calls, reducing the complexity of integrating with multiple providers and AI tools.",
    },
    training: {
      title: "Model Training",
      description: "Train custom AI models to meet your specific needs.",
    },
    speech: {
      title: "AI Conversation",
      description:
        "Chat with AI using voice and text, allowing you to interact with the AI in a natural way.",
    },
  },
  gallery: {
    title: "Image Generation",
    subtitle: "Choose between a variety of image generation models!",
  },
  video: {
    title: "Video Generation",
    subtitle: "Generate new videos with text, images or videoclips",
    feature1: {
      title: "Prompt template",
      description: "Choose appropriate prompt templates for video generation",
    },
    feature2: {
      title: "First and last frame",
      description: "Choose where to start and end your video generation",
    },
    feature3: {
      title: "Video duration",
      description:
        "Choose the duration of the video you want to generate (5-10s)",
    },
  },
  agentChat: {
    title: "In doubt?",
    subtitle: "Ask our AI assistant, it knows everything!",
    button: "Chat",
  },
  faq: {
    title: "In doubt?",
    subtitle: "Frequently Asked Questions",
    questions: {
      models: {
        question: "What are the current AI models available?",
        answer:
          "The current versions of the available models in Araria include GPT-4, Claude 3.5 Sonnet, Gemini 2.0 Flash, Llama 3.3 70B, and Mistral Large 2. We continuously update our model selection to provide the best AI experience.",
      },
      selection: {
        question: "How do you select the AI models?",
        answer:
          "We carefully select the best AI models based on performance benchmarks, including open LLM comparators like lmsys.org and university studies like Berkeley Function Calling Leaderboard and livebench.ai.",
      },
      assistants: {
        question: "What are the Project Assistants?",
        answer:
          "A Project Assistant is a custom AI that you provide with specific knowledge. Thus, it can answer your daily questions without the need to repeat the context. You can compare the performance of your assistants in different models with a click.",
      },
      availability: {
        question: "Can I access all models from anywhere?",
        answer:
          "We provide access to premium AI models using official APIs. Some models may have regional restrictions based on the providers' policies. Araria works on edge servers closer to your location for optimal performance.",
      },
      tokenCount: {
        question: "How many characters are in a token?",
        answer:
          "The number of characters in a token varies according to the model and language, but generally one token is equivalent to a word (4-7 characters per token).",
      },
    },
  },
};
